import React from "react";

const StatCard = ({ value, label, sub }) => (
  <div className="meta-social-ads__stat-card">
    <div className="meta-social-ads__stat-value">{value}</div>
    <div className="meta-social-ads__stat-label">{label}</div>
    {sub && <div className="meta-social-ads__stat-sub">{sub}</div>}
  </div>
);

const SummaryHeader = ({ summary, onResync, syncStatus }) => {
  const isSyncing = syncStatus === "syncing";
  const isFailed = syncStatus === "failed";
  const isBackfilling = syncStatus === "backfilling";

  const lastSynced = summary.lastSyncedAt
    ? new Date(summary.lastSyncedAt).toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        hour: "numeric",
        minute: "2-digit",
      })
    : "Never";

  const syncLabel = isSyncing ? "Syncing..." : isFailed ? "Sync Failed" : lastSynced;

  return (
    <div className="meta-social-ads__header">
      <div className="d-flex align-items-center justify-content-between">
        <h1 className="meta-social-ads__title">Meta Social Ads</h1>
        {onResync ? (
          <button
            className="btn btn-setlist-secondary btn-sm"
            onClick={onResync}
            disabled={isSyncing}
          >
            <i className={`fas fa-sync-alt${isSyncing ? " fa-spin" : ""} mr-1`}></i>
            {isSyncing ? "Syncing..." : "Resync"}
          </button>
        ) : null}
      </div>
      <div className="meta-social-ads__summary">
        <StatCard
          value={summary.totalCampaigns}
          label="Campaigns"
          sub={`${summary.activeCampaigns} active`}
        />
        <StatCard
          value={summary.totalAds}
          label="Ads"
          sub={`${summary.activeAds} active`}
        />
        <StatCard
          value={syncLabel}
          label="Last Synced"
          sub={
            isSyncing || isFailed
              ? summary.syncError
              : isBackfilling
                ? "Loading historical spend…"
                : null
          }
        />
      </div>
    </div>
  );
};

export default SummaryHeader;
